import React, { Component } from 'react';

class Sports extends Component {
  render() {
    return (
        <div class="sports">

	    <h2>This is the Sports Page</h2>

	</div>
    );
  }
}

export default Sports;



// WEBPACK FOOTER //
// ./src/Sports.js